





































let vm: any;
import { Component, Vue, Prop, PropSync, Emit, Watch } from 'vue-property-decorator';
import { MarkViewModel, MarkService } from '@/api/mark.ts';
import { MessageBox } from 'element-ui';
@Component({
})
export default class EditMark extends Vue {
  private service: MarkService = new MarkService();
  private markId: number = 0;
  private data: MarkViewModel = this.service.NewModel;
  private markList = [];
  private showLocation: boolean = false;
  private rules: any = {
    name: [{required: true, message: '请输入名称', trigger: 'blur'}],
    oldAddress: [{required: true, message: '请输入旧址', trigger: 'blur'}],
    lng: [{type: 'number',  message: '请选择位置', trigger: 'blur'}],
  };
  private markOffset!: any;
  private markEvents: any = {
    click: (event: any) => {
      vm.data.lng = event.lnglat.lng;
      vm.data.lat = event.lnglat.lat;
      vm.data.name = event.target.F.label.content.toString();
      vm.data.address = event.target.F.title;
      vm.showLocation = false;
    },
  };
  @Prop() private mapId!: number;
  @Watch('mapId', {immediate: true, deep: true})
  private onmapIdChanged(val: number, oldVal: number) {
    this.service.GetByMapID(val).then((response: any) => {
      this.markList = response;
    });
  }
  private created() {
    vm = this;
  }
  private mounted() {
    if (this.$route.query.id) {
      this.markId = parseInt(this.$route.query.id.toString(), 10);
    }
    if (this.markId > 0) {
      this.service.Get(this.markId).then((response: any) => {
        this.data = response;
      });
    }
  }

  private Edit(entity: any) {
    this.data = entity;
  }

  @Emit('OnCancel')
  private btnCancel_OnClick() {}

  @Emit('OnSave')
  private OnSave(entity: any) {
    return entity;
  }
  @Emit('OnDelete')
  private OnDelete() {

  }
  private btnDelete_OnClick() {
    MessageBox.confirm('是否删除？').then( () => {
      this.service.Delete(this.data.id!).then(() => {
        this.$message.success('删除成功！');
        this.data = this.service.NewModel;
        (this.$refs['edit-form'] as any).resetFields();
        this.OnDelete();
      });
    });
  }

  private btnSave_OnClick() {
    const validate = this.$refs['edit-form'] as any;
    validate.validate((valid: any) => {
      if (valid) {
        if (this.data.id === 0) {
          this.data.mapID = this.mapId;
          this.service.Create(this.data).then((response: any) => {
            this.data = this.service.NewModel;
            (this.$refs['edit-form'] as any).resetFields();
            this.$message.success('保存成功');
            this.OnSave(response);
          });
        } else {
          this.service.Update(this.data).then((response: any) => {
            this.data = this.service.NewModel;
            (this.$refs['edit-form'] as any).resetFields();
            this.$message.success('保存成功');
            this.OnSave(response);
          });
        }
      }
    });
  }
  private btnLocation_OnClick() {
    this.showLocation = true;
  }
  private btnLocationConfirm_OnClick() {
    this.showLocation = false;
  }

  // @Emit('OnSearch')
  // private onSearchResult(pois: any) {
  //   this.showLocation = false;
  //   console.log(pois);
  //   return pois;
  // }

  private SelectLocation(location: any) {
    this.data.lng = location.lnglat.lng;
    this.data.lat = location.lnglat.lat;
    this.data.address = location.address;
  }
}
